import styled from 'styled-components'

export const SectionContainer = styled.div`
  width: 100%;
`

export const SectionLabel = styled.h2`
  font-size: 0.75rem;
  font-weight: 400;
  color: ${({ theme }) => theme.forecast.secondaryText};
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

export const FavoritesGrid = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
`
